/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S12_P1Inputs */

const tr_onbilgi_s12_p1 = /** @type {(inputs: Onbilgi_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu Ön Bilgilendirme Formu, Mesafeli Hizmet Sözleşmesi'nin ayrılmaz ekidir.`)
};

const en_onbilgi_s12_p1 = /** @type {(inputs: Onbilgi_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This Pre-Information Form is an inseparable annex to the Mesafeli Hizmet Sözleşmesi.`)
};

const de_onbilgi_s12_p1 = /** @type {(inputs: Onbilgi_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieses Vorab-Informationsformular ist ein untrennbarer Anhang des Mesafeli Hizmet Sözleşmesi.`)
};

const ru_onbilgi_s12_p1 = /** @type {(inputs: Onbilgi_S12_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Настоящая Форма предварительного информирования является неотъемлемым приложением к Mesafeli Hizmet Sözleşmesi.`)
};

/**
* | output |
* | --- |
* | "This Pre-Information Form is an inseparable annex to the Mesafeli Hizmet Sözleşmesi." |
*
* @param {Onbilgi_S12_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s12_p1 = /** @type {((inputs?: Onbilgi_S12_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S12_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s12_p1(inputs)
	if (locale === "de") return de_onbilgi_s12_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s12_p1(inputs)
	return tr_onbilgi_s12_p1(inputs)
});